export default {
  SET_DOCUMENT_FILE_LIST_LOADING: (state, { value }) =>
    (state.uploads_loading = value),
  SET_DOCUMENT_FILE_LIST: (state, { uploads, hasMore, nextPage }) => {
    state.uploads = uploads;
    state.has_more = hasMore;
    state.next_page = nextPage;
  },
  CONCAT_DOCUMENT_FILE_LIST: (state, { uploads, hasMore, nextPage }) => {
    state.uploads = state.uploads.concat(uploads);
    state.has_more = hasMore;
    state.next_page = nextPage;
  },
  SET_DOCUMENT_FILE_SUBMITTING: (state, { value }) =>
    (state.uploads_submitting = value),
  SET_DOCUMENT_FILE_ERROR: (state, { value }) => (state.uploads_error = value),
  SET_ACTIVE_DOCUMENT_FILE: (state, { upload }) => (state.active_upload = upload),
  SET_DOCUMENT_FILE_EDIT_MODE: (state, { value }) =>
    (state.is_edit_upload = value),
  CLEAR_DOCUMENT_FILE_FORM_STATE: (state) => {
    state.uploads_error = "";
    state.uploads_submitting = false;
    state.active_upload = null;
    state.is_edit_upload = false;
  },
};
